<template>
    <div id="admin_wallet_history">
        <div class="accordion accordion-toggle-arrow" id="userHistoryFilter">
            <div class="card" style="overflow:inherit">
                <div class="card-header bg-transparent" id="headingOne">
                    <div class="card-title collapsed" data-toggle="collapse"
                         data-target="#filterHistoryForm"
                         aria-controls="filterHistoryForm">
                        {{ $t('label.search') }}
                    </div>
                </div>
                <kt-panel>
                    <div id="filterHistoryForm" class="collapse" aria-labelledby="filterHistoryForm" data-parent="#userHistoryFilter">
                        <div class="card-body">
                            <form @submit.prevent="filterAction($event, query)" id="error_form_filter">
                                <kt-form-section>
                                    <kt-form-row>
                                        <kt-col xs="12" sm="3" md="3" class="mb-2">
                                            <kt-form-group>
                                                <kt-form-label for="from_date">
                                                    {{ $t('search_fields.common.from_date') }}
                                                </kt-form-label>
                                                <button id="reset_from_date"
                                                        @click="clearFromDate"
                                                        class=" btn btn-label-danger trash-btn"
                                                >
                                                    <i class="la la-trash-o"></i>
                                                </button>
                                                <datePicker
                                                    format="YYYY-MM-DD HH:mm:ss"
                                                    display-format="dddd jDD jMMMM jYYYY HH:mm"
                                                    input-class="form-control"
                                                    id="from_date"
                                                    name= "from_date"
                                                    v-model="query.from_date"
                                                    type="datetime" />
                                            </kt-form-group>
                                        </kt-col>
                                        <kt-col xs="12" sm="3" md="3" class="mb-2">
                                            <kt-form-group>
                                                <kt-form-label for="to_date">
                                                    {{ $t('search_fields.common.to_date') }}
                                                </kt-form-label>
                                                <button id="reset_to_date"
                                                        @click="clearToDate"
                                                        class=" btn btn-label-danger trash-btn"
                                                >
                                                    <i class="la la-trash-o"></i>
                                                </button>
                                                <datePicker
                                                    format="YYYY-MM-DD HH:mm:ss"
                                                    display-format="dddd jDD jMMMM jYYYY HH:mm"
                                                    input-class="form-control"
                                                    id="to_date"
                                                    name= "to_date"
                                                    v-model="query.to_date"
                                                    type="datetime"
                                                />
                                            </kt-form-group>
                                        </kt-col>
                                        <kt-col xs="12" sm="3" md="3" class="mb-2">
                                            <kt-form-group>
                                                <kt-form-label for="to_date">
                                                    {{ $t('search_fields.common.payment_date_from') }}
                                                </kt-form-label>
                                                <button id="reset_payment_date_from"
                                                        @click="clearPaymentDateFrom"
                                                        class=" btn btn-label-danger trash-btn"
                                                >
                                                    <i class="la la-trash-o"></i>
                                                </button>
                                                <datePicker
                                                    format="YYYY-MM-DD HH:mm:ss"
                                                    display-format="dddd jDD jMMMM jYYYY HH:mm"
                                                    input-class="form-control"
                                                    id="payment_date_from"
                                                    name= "payment_date_from"
                                                    v-model="query.payment_date_from"
                                                    type="datetime"
                                                />
                                            </kt-form-group>
                                        </kt-col>
                                        <kt-col xs="12" sm="3" md="3" class="mb-2">
                                            <kt-form-group>
                                                <kt-form-label for="to_date">
                                                    {{ $t('search_fields.common.payment_date_to') }}
                                                </kt-form-label>
                                                <button id="reset_payment_date_to"
                                                        @click="clearPaymentDateTo"
                                                        class=" btn btn-label-danger trash-btn"
                                                >
                                                    <i class="la la-trash-o"></i>
                                                </button>
                                                <datePicker
                                                    format="YYYY-MM-DD HH:mm:ss"
                                                    display-format="dddd jDD jMMMM jYYYY HH:mm"
                                                    input-class="form-control"
                                                    id="payment_date_to"
                                                    name= "payment_date_to"
                                                    v-model="query.payment_date_to"
                                                    type="datetime"
                                                />
                                            </kt-form-group>
                                        </kt-col>
                                        <kt-col xs="12" sm="3" md="3" class="mb-2">
                                            <kt-form-group ref="bankNameSelectGroup">
                                                <kt-form-label for="bankName">
                                                    {{ $t('search_fields.common.bank_name') }}
                                                </kt-form-label>
                                                <kt-form-select size="5" id="bankName" class="form-control"
                                                                name="bankName" v-model="query.bank_id"
                                                >
                                                    <option :value="null" v-text="$t('selectpicker.select_all')"
                                                    ></option>
                                                    <option v-for="(id, index) in bankId.mostUsedIds()"
                                                            :value="id"
                                                            :key="index"
                                                            v-text="bankIdStr.get(id)"
                                                    ></option>
                                                </kt-form-select>
                                            </kt-form-group>
                                        </kt-col>
                                        <kt-col xs="12" sm="3" md="3" class="mb-2">
                                            <label for="request"
                                                   v-text="$t('search_fields.common.request')"
                                            >
                                            </label>
                                            <input type="text"
                                                   id="request"
                                                   name= "request"
                                                   class="form-control"
                                                   v-model="query.request"
                                            >
                                        </kt-col>
                                        <kt-col xs="12" sm="3" md="3" class="mb-2">
                                            <label for="response"
                                                   v-text="$t('search_fields.common.response')"
                                            >
                                            </label>
                                            <input type="text"
                                                   id="response"
                                                   name= "response"
                                                   class="form-control"
                                                   v-model="query.response"
                                            >
                                        </kt-col>
                                        <kt-col xs="12" sm="3" md="3" class="mb-2">
                                            <label for="account_number"
                                                   v-text="$t('search_fields.common.source_account_number')"
                                            >
                                            </label>
                                            <input type="text"
                                                   id="account_number"
                                                   name= "account_number"
                                                   class="form-control"
                                                   v-model="query.account_number"
                                            >
                                        </kt-col>
                                        <kt-col xs="12" sm="3" md="3" class="mb-2">
                                            <label for="destination_iban"
                                                   v-text="$t('search_fields.common.destination_iban')"
                                            >
                                            </label>
                                            <input type="text"
                                                   id="destination_iban"
                                                   name= "destination_iban"
                                                   class="form-control"
                                                   v-model="query.destination_iban"
                                            >
                                        </kt-col>
                                        <kt-col xs="12" sm="3" md="3" class="mb-2">
                                            <label for="wallet_transaction_id"
                                                   v-text="$t('search_fields.common.wallet_transaction_id')"
                                            >
                                            </label>
                                            <input type="text"
                                                   id="wallet_transaction_id"
                                                   name= "wallet_transaction_id"
                                                   class="form-control"
                                                   v-model="query.wallet_transaction_id"
                                            >
                                        </kt-col>
                                        <kt-col xs="12" sm="3" md="3" class="mb-2">
                                            <label for="wallet_id"
                                                   v-text="$t('search_fields.common.wallet_id')"
                                            >
                                            </label>
                                            <input type="text"
                                                   id="wallet_id"
                                                   name= "wallet_id"
                                                   class="form-control"
                                                   v-model="query.wallet_id"
                                            >
                                        </kt-col>
                                    </kt-form-row>
                                </kt-form-section>
                                <kt-form-section>
                                    <kt-row>
                                        <kt-col xs="12" sm="6" md="6" class="mt-4">
                                            <input type="submit" class="btn btn-success btn-wide" :value="$t('label.filter')">
                                        </kt-col>
                                    </kt-row>
                                </kt-form-section>
                            </form>
                        </div>
                    </div>
                </kt-panel>
            </div>
        </div>
        <kt-datatable ref="datatable" v-bind="datatableProps"></kt-datatable>
    </div>
</template>

<script>
import {ApiUrl} from "@/common/api.service";
import {AuthorizationHeader} from "@/common/jwt.service";
import columns from "../datatable/history-columns.js";
import {bankId, bankIdStr} from "@/constants/bankId";
import {companies, companiesStr} from "@/constants/companies";


export default {
    props: {
        api_base_path: {
            default: ApiUrl.path(''),
            type: String
        }
    },
    components: {
    },
    data() {
        return {
            query: {},
        };
    },
    methods: {
        filterAction(e, query) {
            this.query = query;

            if (this.$refs.datatable.KTDatatable) {
                this.$refs.datatable.reload();
            }
        },
        clearFromDate() {
            if (this.query.from_date) {
                this.query.from_date = null;
            }
        },
        clearToDate() {
            if (this.query.to_date) {
                this.query.to_date = null;
            }
        },
        clearPaymentDateFrom() {
            if (this.query.payment_date_from) {
                this.query.payment_date_from = null;
            }
        },
        clearPaymentDateTo() {
            if (this.query.payment_date_to) {
                this.query.payment_date_to = null;
            }
        },
    },
    computed: {
        companiesStr() {
            return companiesStr
        },
        companies() {
            return companies
        },
        bankIdStr() {
            return bankIdStr
        },
        bankId() {
            return bankId
        },
        datatableProps() {
            return {
                id: "wallets_history_datatable",
                data: {
                    type: 'remote',
                    source: {
                        read: {
                            url: this.api_base_path + 'wallet/common/admin/history/settlement',
                            method: 'GET',
                            headers: AuthorizationHeader,
                            map: res => {
                                return res.data.data;
                            },
                            params: this.query,
                        }
                    },
                    pageSize: 10,
                    serverPaging: true,
                    serverFiltering: true,
                    serverSorting: true,
                },
                layout: {},
                pagination: false,
                columns: columns,
            }
        },
    },
}
</script>
